import * as React from 'react';
import { Dialog } from 'sos-common/js/components/Dialog/Dialog';
import { Icon } from 'sos-common/js/components/Icon/icon';
import './DeleteOrder.scss';

export interface DeleteOrderProps {
  isActive?: boolean;
  modalHeading: string;
  modalBody: string;
  cancelText: string;
  actionText: string;
  disabled: boolean;
  onActionCompleted?(): void;
}

export interface DeleteOrderState {
  isModalOpen: boolean;
}

export class DeleteOrder extends React.Component<DeleteOrderProps, DeleteOrderState> {
  constructor(props: DeleteOrderProps) {
    super(props);

    this.state = {
      isModalOpen: false,
    };
  }

  //this will be resposibility of the store.
  onActionCompleted = () => this.props.onActionCompleted();

  doDelete = () => {
    //const {deletePath} = this.props
    this.closeConfirm();
    this.onActionCompleted();
  };

  openConfirm = (e: React.MouseEvent) => {
    e.preventDefault();

    this.setState({
      isModalOpen: true,
    });
  };

  closeConfirm = () => {
    this.setState({
      isModalOpen: false,
    });
  };

  public render() {
    const { isModalOpen } = this.state;
    const { modalHeading, modalBody, cancelText, actionText, disabled } = this.props;

    return (
      <div className="eservicemenu">
        {/*<button onClick={this.openConfirm} disabled={disabled} className='eservice-navigation__link eservice-navigation__link--destructive stripped-button'>
            <Icon iconType="Paperbin" />
            Radera beställning
        </button>*/}
        <Dialog isOpen={isModalOpen} onRequestClose={this.closeConfirm}>
          <button onClick={this.closeConfirm} className="close">
            <Icon isAriaHidden={false} ariaLabel="Stäng" iconType="ic_close_white_24px" />
          </button>
          <div className="header">
            <h2>{modalHeading}</h2>
          </div>
          <p>{modalBody}</p>
          <div className="footer">
            <button className="button button--white" onClick={this.closeConfirm}>
              {cancelText}
            </button>
            <button className="button button--red" onClick={this.doDelete}>
              {actionText}
            </button>
          </div>
        </Dialog>
      </div>
    );
  }
}

// function deleteItem(link: string) {
//     return fetch(link, {
//       method: "GET",
//       cache: "no-cache",
//     })
//     .then(response => console.log(response));
//   }
